import React from 'react';
import ReportPageWithMonthWeekSwitch from './components/ReportPageWithMonthWeekSwitch';
import KeysByMonthBySkuList from './components/month/KeysByMonthBySkuList';
import KeysByWeekBySkuList from './components/week/KeysByWeekBySkuList';

function KeysBySku() {
  return (
    <ReportPageWithMonthWeekSwitch
      title="Keys by SKU"
      MonthList={KeysByMonthBySkuList}
      WeekList={KeysByWeekBySkuList}
    />
  );
}

export default KeysBySku;
